module.exports = __webpack_public_path__ + "static/media/mobile-close.9b863edb.svg";